<template>
    <div
      class="w-full z-10 bg-white rounded-xl relative border-2 border-white after:z-0 after:bg-PURPLE after:absolute after:top-0 after:w-1/2 after:h-full after:rounded-[10px] after:transition-all after:duration-300"
      :class="
        activeTab === 0
          ? 'after:left-0'
          : 'after:left-1/2'
      "
    >
      <button
        @click="changeActiveTab(0)"
        class="text-sm font-semibold py-2.5 w-1/2 transition-all duration-500 relative z-[1]"
        :class="activeTab === 0 ? 'text-white ' : 'text-black'"
      >
        Character
      </button>
      <button
        @click="changeActiveTab(1)"
        class="text-sm font-semibold py-2.5 w-1/2 transition-all duration-500 relative z-[1]"
        :class="activeTab === 1 ? 'text-white ' : 'text-black'"
      >
        Skin
      </button>
    </div>
  </template>
  <script setup>
  import { onMounted, ref } from 'vue'
  
  const emit = defineEmits(['update:modelValue'])
  const activeTab = ref(0)
  
  const changeActiveTab = (index) => {
    activeTab.value = index
    emit('update:modelValue', index)
  }
  
  onMounted(() => {
    emit('update:modelValue', activeTab.value)
  })
  </script>
  